(() => {
  function initViva(root = document) {
    root.querySelectorAll('.viva-menu-toggle').forEach(button => {
      if (button.dataset.vivaReady) return;
      const menu = button.closest('.viva-header').querySelector('.viva-mobile-nav');
      if (!menu) return;
      button.dataset.vivaReady = 'true';
      const close = () => {
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-label', 'Open navigation');
        menu.hidden = true;
      };
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        menu.hidden = expanded;
        button.setAttribute('aria-expanded', String(!expanded));
        button.setAttribute('aria-label', expanded ? 'Open navigation' : 'Close navigation');
      });
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', close));
      button.closest('.viva-header').addEventListener('keydown', event => {
        if (event.key === 'Escape' && !menu.hidden) { close(); button.focus(); }
      });
      const desktop = window.matchMedia('(min-width: 761px)');
      desktop.addEventListener('change', event => { if (event.matches) close(); });
    });
  }
  initViva();
  document.addEventListener('shopify:section:load', event => initViva(event.target));
})();
